import {ReactNode} from "react";
import {Circle, HStack, Text} from "@chakra-ui/react";
import {OUTCOME_LABEL} from "../model";
import {NodeScope} from "./useLayeredGraph";

/**
 * There is one thing to read from a control you lean on: whether it concluded in a way that
 * supports reliance. The dependency views show that and nothing else — a control's design does not
 * depend on another control's design, so there is no matching module to line up.
 */
export const scopeIsUnfavourable = (scope: NodeScope): boolean => !scope.supportsReliance;

export function ConclusionValue({scope}: {scope: NodeScope}) {
  if (!scope.outcome) {
    return (
      <Text fontStyle="italic" color="gray.500">
        Not concluded
      </Text>
    );
  }
  return (
    <HStack gap={1.5}>
      <Circle bg={scope.supportsReliance ? "green.500" : "red.500"} size="8px" />
      <Text color="gray.700">{OUTCOME_LABEL[scope.outcome]}</Text>
    </HStack>
  );
}

/** Inline labelled row — used on a single-scope card body. */
export function ConclusionLine({label, scope}: {label: ReactNode; scope: NodeScope}) {
  return (
    <HStack gap={2} fontSize="xs" justify="space-between">
      <Text fontWeight="semibold" color="gray.700">
        {label}
      </Text>
      <ConclusionValue scope={scope} />
    </HStack>
  );
}
